import { css } from '@emotion/react';
import { Secondary, p2r } from '../../../styles/fonts';
import { colors, breakpoints } from '../../../styles';

const { white } = colors;

const styles = (backgroundColor) => css`
  .small-card {
    display: grid;
    grid-template-columns: 50% 50%;
    max-width: 492px;
    min-height: ${p2r(246)};
    color: ${white};

    .small-card__description-sponsor {
      align-items: flex-end;
      justify-content: space-around;
      padding: ${p2r(20)} 22px ${p2r(20)} 32px;

      @media (max-width: ${breakpoints.mobile}px) {
        padding: ${p2r(16)};
      }
    }
  }

  .plug-container {
    width: 246px;
    min-height: ${p2r(246)};
    background-color: ${colors.darkGray};
  }

  .plug-container-mobile {
    display: none;
    width: 246px;
    min-height: ${p2r(246)};
    background-color: ${colors.darkGray};
  }

  .small-card__description {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    width: 100%;
    max-width: 100%;
    padding: ${p2r(15)} 32px;
    background-color: ${backgroundColor};

    .text-header {
      display: flex;
      align-items: center;
      height: 100%;
      padding-bottom: ${p2r(27)};
    }
  }

  .small-card__description-logo {
    max-width: 64px;
  }

  .small-card__image-container {
    overflow: hidden;
  }

  .small-card__image {
    max-width: 246px;
    object-fit: cover;

    &--mobile {
      display: none;
    }
  }

  .small-card__image,
  .small-card__image--mobile {
    width: 100%;
    height: 100%;
    transition: transform 0.5s ease;
  }

  .small-card:hover .small-card__image,
  .small-card:hover .small-card__image--mobile {
    transform: scale(1.2);
  }

  .small-card:hover > .small-card__description {
    text-decoration: underline;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .small-card__description {
      padding: ${p2r(16)};

      .text-header {
        padding-bottom: 0;
      }
    }

    .small-card__description-logo {
      padding-top: 0;
    }

    .plug-container {
      display: none;
    }

    .plug-container-mobile {
      display: block;
    }

    .small-card__image {
      display: none;

      &--mobile {
        display: block;
      }
    }
  }

  @media (max-width: ${breakpoints.mobile}px) {
    .small-card {
      min-height: ${p2r(172)};
    }

    .small-card__image {
      max-width: 172px;
    }

    .small-card__description .text-header {
      font: normal normal 500 ${p2r(20)} / ${p2r(24)} ${Secondary};
    }
  }
`;

export default styles;
